


/**
 * Friendly name for life safisfaction from OONS
 * @param {*} score 
 */
export function lifeSatisifactionFriendly(score) {
    if (score <= 4) {
        return 'location.lifeSatisfactionLow';
    }

    if (score <= 6) {
        return 'location.lifeSatisfactionMedium';
    }

    if (score <= 8) {
        return 'location.lifeSatisfactionHigh';
    }

    return 'location.lifeSatisfactionVeryHigh';
}


/**
 * Converts "Hello test" to "hello-test"
 * @param {*} input 
 */
export function  convertToSlug(input)
{
    return input
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-');
}